import { render } from "./RoleManageModel.vue?vue&type=template&id=04bf9906"
import script from "./RoleManageModel.js?vue&type=script&lang=js"
export * from "./RoleManageModel.js?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__